import { OrderModel } from "../../screens/portfolio-info/types/OrderModel";
import { AssetType } from "../types/AssetType";
import { PortfolioGroupedItemModel } from "../../screens/portfolio-summary/types/PortfolioGroupedItemModel";
import { PositionModel } from "../../screens/portfolio-info/types/PositionModel";
import { PortfolioGroupedItem } from "../../screens/positions-and-orders/models/PortfolioGroupedItem";

class AssetService {
    isOption = (order: OrderModel): boolean =>
        order.type === AssetType.Call || order.type === AssetType.Put;
    
    isOptionType = (type: AssetType): boolean =>
        type === AssetType.Call || type === AssetType.Put;
    
    isOptionExpired = (order: OrderModel): boolean =>
        order.expirationPrice !== null;

    isGroupedOptions = (item: PortfolioGroupedItemModel): boolean =>
        item.type === AssetType.Call || item.type === AssetType.Put;

    isGroupedOptionsExpired = (item: PortfolioGroupedItemModel): boolean =>
        item.expirationPrice !== null;

    isOptionPositionExpired = (item: PortfolioGroupedItem): boolean =>
        item.expirationPrice !== null;
    
    isPositionOption = (item: PositionModel): boolean =>
        item.type === AssetType.Call || item.type === AssetType.Put;

    isPositionOptionExpired = (position: PositionModel): boolean =>
        position.expirationPrice !== null;
}

export const assetService = new AssetService();
